module.exports = __webpack_public_path__ + "static/media/bg-partner-definitive.8e55fefb.webp";